import React from 'react'
import Layout from './Layout'
import { Link } from 'react-router-dom'

export default function Physics() {
  return (
    <Layout page={<div>
      <h1>Physics</h1>
      <h3>Modern Physics & Quantum Mechanics</h3>
      <ul>
        <Link to='/file/physics/Modern Physics & Quantum mechanics.pdf'>Modern Physics & Quantum mechanics.pdff</Link>
        <Link to='/file/physics/de Broglie numericals.pdf'>de Broglie numericals.pdf</Link>
        <Link to='/file/physics/Numericals_Particle in a box.pdf'>Numericals_Particle in a box.pdf</Link>
        <Link to='/file/physics/Unertainty Principle_numerical.pdf'>Unertainty Principle_numerical.pdf</Link>
      </ul>
      <h3>SHM & Shock Waves</h3>
      <ul>
        <Link to='/file/physics/Simple harmonic motion.pdf'>Simple harmonic motion.pdf</Link>
        <Link to='/file/physics/Shock waves.pdf'>Shock waves.pdf</Link>
      </ul>
      <h3>Electrical Conductivity in Solids</h3>
      <ul>
        <Link to='/file/physics/Dielectric properties of Material.pdf'>Dielectric properties of Material.pdf</Link>
        <Link to='/file/physics/Semiconductors.pdf'>Semiconductors.pdf</Link>
        <Link to='/file/physics/ELECTRICAL conductivity in metals.pdf'>ELECTRICAL conductivity in metals.pdf</Link>
        <Link to='/file/physics/Electrical conductivity Numericals.pdf'>Electrical conductivity Numericals.pdf</Link>
        <Link to='/file/physics/Numerical On Dielectric.pdf'>Numerical On Dielectric.pdf</Link>
        <Link to='/file/physics/Numerical_semiconductors.pdf'>Numerical_semiconductors.pdf</Link>
      </ul>
      <h3>LASER & Optical Fibers</h3>
      <ul>
        <Link to='/file/physics/Laser.pdf'>Laser.pdf</Link>
        <Link to='/file/physics/Optical fibers final.pdf'>Optical fibers final.pdf</Link>
        <Link to='/file/physics/Laser numerical.pdf'>Laser numerical.pdf</Link>
        <Link to='/file/physics/Optical fibers numerical.pdf'>Optical fibers numerical.pdf</Link>
      </ul>
      <h3>Material Characterization Techniques & Instrumentation</h3>
      <ul>
        <Link to='/file/physics/Module 5.pdf'>Module 5.pdf</Link>
      </ul>
      <h3>Lab Manual</h3>
      <ul>
        <Link to='/file/physics/PHYSICS lab manual_ Final.pdf'>PHYSICS lab manual_ Final.pdf</Link>
        <Link to='/file/physics/VIVA QUESTIONS AND ANSWERS.pdf'>VIVA QUESTIONS AND ANSWERS.pdf</Link>
      </ul>
    </div>} />
  )
}
